import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import RolDocTypes from './RolDocTypes';
import UserDocTypes from './UserDocTypes';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const styles = {
    '& .MuiTabs-root': {
        textTransform: 'none',
        color: 'var(--primary)',
        '& .Mui-selected': {
            color: 'var(--primary)'
        },
        '& .MuiTabs-flexContainer': {
            width: 'auto',
            '& button': {
                width: '50%',
                fontSize: '16px',
                textTransform: 'none'
            }
        }
    }
};

function RenderComponent({ value }: { value: number }) {
    switch (value) {
        case 0:
            return <RolDocTypes />;
        case 1:
            return <>B</>;
        default:
            return <>C</>;
    }
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`cdd-agente-tabpanel-${index}`}
            aria-labelledby={`cdd-agente-tab-${index}`}
            style={{ height: 'calc(100% - 222px)' }}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2, minHeight: '250px' }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `cdd-agente-tab-${index}`,
        'aria-controls': `cdd-agente-tabpanel-${index}`
    };
}

function TabPanel({ data, tabValue, handleChangeTabValue, ...props }: any) {
    return (
        <>
            <Box sx={{ ...styles }}>
                <Tabs onChange={handleChangeTabValue} value={tabValue > 0 ? tabValue : 0}>
                    <Tab label="Tipos de documentos asociados al rol" {...a11yProps(0)} />
                    <Tab label="Tipos de documentos asociados al usuario" {...a11yProps(1)} />
                </Tabs>
            </Box>

            {data?.idRol ? (
                <>
                    <CustomTabPanel value={tabValue} index={0}>
                        <RolDocTypes items={data?.idRol?.permisos} />
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                        <UserDocTypes data={data} {...props} />
                    </CustomTabPanel>
                </>
            ) : (
                <Box color="#656565" py={4} display="flex" justifyContent="center">
                    <p>Seleccioná un rol para ver los tipos de documentos asociados</p>
                </Box>
            )}
        </>
    );
}

export default TabPanel;
